<ng-container *transloco="let t">
  @if (topic$ | async; as topic) {
    <cft-holy-grail-grid>
      <cft-holy-grail-grid-col-left>
        @if (latestArticles$ | async; as articles) {
          <bgo-sidenav-articles
            class="sticky top-12 z-20 block"
            [articles]="articles"
            [topics]="topic.moreTopics"
          ></bgo-sidenav-articles>
        }
      </cft-holy-grail-grid-col-left>
      <cft-holy-grail-grid-content>
        <cft-hero-cover [showBreadcrumbs]="true">
          @if (breadcrumbs$ | async; as breadcrumbs) {
            <cft-breadcrumbs [showBackButton]="false" [breadcrumbs]="breadcrumbs"></cft-breadcrumbs>
          }
          <h1 bgo-hero-cover-title ngProjectAs="cft-hero-cover-title">{{ topic.title }}</h1>
          <cft-hero-cover-plot>{{ topic.description }}</cft-hero-cover-plot>
        </cft-hero-cover>
        <h2 class="mt-md plot-md">
          @if (articles$ | async; as articles) {
            @if (!activatedSearchTerm) {
              {{ t('topic.search.results', {num: articles.total, topic: topic.breadcrumbTitle || topic.title}) }}
            } @else {
              {{
                t('topic.search.resultsWithTerm', {
                  num: articles.total,
                  topic: topic.breadcrumbTitle || topic.title,
                  term: activatedSearchTerm,
                })
              }}
            }
          }
        </h2>
        <section class="mt-sm">
          <cft-searchbar
            class="max-w-md"
            [placeholder]="t('topic.search.placeholder')"
            [formControlInput]="searchControl"
          />
          <cft-sorting-bar class="mt-sm">
            <div class="cursor-not-allowed px-xs py-2xs">
              @if (activatedSearchTerm) {
                {{ t('topic.search.byRelevance') }}
              } @else {
                {{ t('topic.search.byDate') }}
              }
            </div>
          </cft-sorting-bar>
        </section>
        <section class="grid-2-cols-teaser-cards mt-md">
          @if (articles$ | async; as articles) {
            @for (article of articles.items; track article.slug) {
              <bgo-article-preview [article]="article"></bgo-article-preview>
            } @empty {
              <cft-message [icon]="infoIcon" [title]="t('topic.search.noResults.title')">
                {{
                  t('topic.search.noResults.label', {
                    topic: topic.breadcrumbTitle || topic.title,
                  })
                }}
              </cft-message>
            }
            @if (articles.items.length < articles.total) {
              <div class="col-span-full mt-sm justify-self-center">
                <button
                  (click)="loadMoreArticles(articles.items.length)"
                  cft-button
                  [isLoading$]="isLoadingMore$"
                  class="btn btn-primary"
                >
                  {{ t('topic.loadMore') }}
                </button>
              </div>
            }
          } @else {
            <div class="col-span-full mt-2xl justify-self-center">
              <cft-spinner />
            </div>
          }
        </section>
      </cft-holy-grail-grid-content>
    </cft-holy-grail-grid>
  }
</ng-container>
